<div class="padding flex column fix-width">
	<b>Ready for approval</b>
	<img class="pickup-image margin-bottom-small margin-top-small" src="assets/approve.png" alt="Pickup ready" />

	<div class="bg-green white padding-small margin-bottom-small">
		<i class="fa-solid fa-check margin-right-smallest"></i>
		Shooting is completed!
	</div>

	<div>You can now approve or reject shots.</div>

	<div class="flex column end full-width margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked">
				<i class="fa-solid fa-check"></i>
				Close
			</button>
		</div>
	</div>
</div>
